<template>
  <div class="imageNav">
      <div class="nav_wrapper">
        <div class="choose_article">        
            <router-link to="/dostup_k_informacii" class="article-item">        
                <img alt="" title="Доступ к информации" src="../assets/img/01.png" />       
            </router-link>

            <router-link to="/diffamatsiya" class="article-item">         
                    <img alt="" title="Диффамация" src="../assets/img/02.png" />         
            </router-link>

            <router-link to="/deti_v_smi" class="article-item">         
                    <img alt="" title="Дети в СМИ" src="../assets/img/03.png" />
            </router-link>

            <router-link to="/pravo_na_izobrajenie" class="article-item">         
                    <img alt="" title="Право на изображение" src="../assets/img/04.png" />
            </router-link>

                <router-link to="/glasnost" class="article-item">         
                    <img alt="" title="Гласность судебного разбирательства" src="../assets/img/05.png" />
            </router-link>

                <router-link to="/avtorskoe_pravo" class="article-item">
                    <img alt="" title="Авторское право" src="../assets/img/06.png" />
            </router-link>

                <router-link to="/accreditaciya" class="article-item">         
                    <img alt="" title="Аккредитация" src="../assets/img/07.png" />
            </router-link>

                <router-link to="/internet" class="article-item">         
                    <img alt="" title="Интернет-регулирование" src="../assets/img/08.png" />
            </router-link>

                <router-link to="/deyatelnost_jurnalista" class="article-item">
                    <img alt="" title="Воспрепятствование деятельности журналиста" src="../assets/img/09.png" />
            </router-link>

                <router-link to="/goszakaz" class="article-item">         
                    <img alt="" title="Госинформзаказ" src="../assets/img/10.png" />
            </router-link>

                <router-link to="/registraciya_smi" class="article-item">         
                    <img alt="" title="Регистрация СМИ" src="../assets/img/11.png" />
            </router-link>

                <router-link to="/samoregulaciya" class="article-item">
                    <img alt="" title="Саморегуляция и этические нормы" src="../assets/img/12.png" />
            </router-link>

                <router-link to="/status" class="article-item">
                    <img alt="" title="Статус журналиста" src="../assets/img/13.png" />
            </router-link>
        </div>
    </div>  
  </div>
</template>

<script>


export default {
  name: "imageNav",
  props: {
    /* msg: String */
  }
};
</script>

<style scoped lang="scss">

.nav_wrapper {
  background-color: #565267;
  display:flex; 
}

.choose_article {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: auto;
    padding: 20px 0;

    img {
        width: 70px;
        margin: 10px;
        @media(max-width: 800px){
          width: 60px;
          margin: 10px 8px;
      } 
    }

    img:hover {
        //transform: scale(1.2);
        transition: all 0.3s;
    }
}

</style>
